var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  tooltip:
                    _vm.modelValue.selectedImpuesto !== null &&
                    _vm.modelValue.selectedImpuesto !== undefined
                      ? _vm.modelValue.selectedImpuesto.nombre
                      : "Seleccione...",
                  label: "nombre",
                  options: _vm.impuestos,
                  id: "impuesto",
                  placeholder: "Seleccione..."
                },
                on: { input: _vm.cargarTarifas },
                model: {
                  value: _vm.modelValue.selectedImpuesto,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "selectedImpuesto", $$v)
                  },
                  expression: "modelValue.selectedImpuesto"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "impuesto" } }, [_vm._v("Impuesto")]),
              _vm._v(" "),
              _vm.errores.selectedImpuesto
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.selectedImpuesto[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  tooltip:
                    _vm.modelValue.selectedTarifa !== null &&
                    _vm.modelValue.selectedTarifa !== undefined
                      ? _vm.modelValue.selectedTarifa.nombre
                      : "Seleccione...",
                  label: "nombre",
                  options: _vm.tarifas,
                  id: "tarifa",
                  placeholder: "Seleccione..."
                },
                on: { input: _vm.setearPorcentaje },
                model: {
                  value: _vm.modelValue.selectedTarifa,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "selectedTarifa", $$v)
                  },
                  expression: "modelValue.selectedTarifa"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "tarifa" } }, [
                _vm._v("Tarifa de impuesto")
              ]),
              _vm._v(" "),
              _vm.errores.selectedTarifa
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.selectedTarifa[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.money,
                  id: "baseImponible",
                  placeholder: "$ ##.##"
                },
                on: { input: _vm.calcularValor },
                model: {
                  value: _vm.modelValue.base_imponible,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "base_imponible", $$v)
                  },
                  expression: "modelValue.base_imponible"
                }
              },
              [
                _c("span", [_vm._v("Base imponible")]),
                _vm._v(" "),
                _vm.errores.base_imponible
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.base_imponible[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.esBanano,
                expression: "esBanano"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                attrs: { vMoney: "", format: _vm.int, id: "numero_cajas" },
                model: {
                  value: _vm.modelValue.numero_cajas,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_cajas", $$v)
                  },
                  expression: "modelValue.numero_cajas"
                }
              },
              [_c("span", [_vm._v("Número de cajas")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.venta,
                expression: "!venta"
              }
            ],
            staticClass: "form-field select2"
          },
          [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    tooltip:
                      _vm.selectedSustento != null
                        ? _vm.selectedSustento.nombre
                        : "Seleccione...",
                    label: "nombre",
                    options: _vm.sustentosTributarios,
                    id: "sustento_tributario",
                    placeholder: "Seleccione..."
                  },
                  on: { input: _vm.inputSustento },
                  model: {
                    value: _vm.selectedSustento,
                    callback: function($$v) {
                      _vm.selectedSustento = $$v
                    },
                    expression: "selectedSustento"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "sustento_tributario" } }, [
                  _vm._v("Sustento Tributario")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.porcentaje,
                  readonly: !_vm.venta,
                  id: "porcentaje",
                  placeholder: "###.## %"
                },
                on: { input: _vm.calcularValor },
                model: {
                  value: _vm.modelValue.porcentaje,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "porcentaje", $$v)
                  },
                  expression: "modelValue.porcentaje"
                }
              },
              [_c("span", [_vm._v("Porcentaje")])]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.money,
                  readonly: "",
                  id: "porcentaje",
                  placeholder: "$ ###.##"
                },
                model: {
                  value: _vm.modelValue.valor,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "valor", $$v)
                  },
                  expression: "modelValue.valor"
                }
              },
              [_c("span", [_vm._v("Valor")])]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.esBanano,
                expression: "esBanano"
              }
            ],
            staticClass: "form-field"
          },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.money,
                  id: "precio_caja",
                  placeholder: "$ ##.##"
                },
                model: {
                  value: _vm.modelValue.precio_caja,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "precio_caja", $$v)
                  },
                  expression: "modelValue.precio_caja"
                }
              },
              [_c("span", [_vm._v("Precio de caja")])]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _vm._v(" "),
          _c("span", [_vm._v("Cancelar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _vm._v(" "),
          _c("span", [_vm._v("Aceptar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Detalle de retención")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d8b81fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8b81fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemRetencion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6d8b81fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemRetencion.vue
// module chunks = 0